export default __webpack_public_path__ + "static/media/VisaPure.91eb503b.svg";